import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { CustomSnackbarService } from '../pages/shared/custom-snackbar/custom-snackbar.service';
import { AlertService } from '../pages/shared/alert/alert.service';
import { ConfigService } from './config.service';
import { Observable , from, of} from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MenuDataResolverService implements Resolve<any>{

  constructor(public service: ConfigService, private route: Router, public snackbarService: CustomSnackbarService, public alert: AlertService) { }
  resolve(): Observable<any> {
    // Check if user is authenticated before making API call
    const accessToken = localStorage.getItem('access_token');
    
    if (!accessToken) {
      // No token, redirect to login
      this.route.navigate(['login']);
      return of(null);
    }

    return from(this.service.getApi('/api/auth/side-menu', {}, '', 'auth_service')).pipe(
      catchError(error => {
        console.error('Side menu API error:', error);
        
        // Check for 401 authentication errors
        if (error?.error?.message === 'Authorization Token not found' || 
            error?.error?.message === 'Token is Expired' ||
            error?.status === 401) {
          
          // Use centralized authentication error handler
          this.service.handleAuthenticationError(error?.error?.message);
        }
        
        return of(null);
      })
    );
  }
}
